import type { StateMatcherOutput } from 'core/http/root/courier.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CourierService } from 'core/http/root/courier.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class StateMatchersResolver {
  constructor(private courierService: CourierService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<StateMatcherOutput[]> {
    return this.courierService.getMatchers(route.params.courierId).pipe(
      tap((matchers) => {
        const priorities = matchers.map(m => m.priority);
        const emptyPriorities = (new Array<number>()).fill(0, 0, priorities.length);

        if (JSON.stringify(priorities) === JSON.stringify(emptyPriorities)) {
          let priority = 0;

          for (const matcher of matchers) {
            matcher.priority = priority++;
          }
        }
      }),
    );
  }
}
